import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

function IconButtonComponent({ label, onClick, arrow }) {
  return (
    <IconButton
      style={{
        color: '#D9D9D9',
        background: '#FFFFFF',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'end',
        justifyContent: 'end',
        width: '60%',
        height: '38px',
        padding: '9px 13px 9px 17px',
        borderRadius: '6px',
        border: '1px solid #D9D9D9',
        gap: '10px',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
      }}

      onClick={onClick}
    >
      <div
        style={{
          fontFamily: 'Poppins',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
          letterSpacing: '0em',
          textAlign: 'left',
          color: '#888DA880',
          marginRight: '5px',
        }}
      >
        {label}
      </div>
      <KeyboardArrowDownIcon
        style={{
          width: '20px',
          height: '20px',
          color: '#888DA880',
          position: 'absolute',
          top: '10px',
          right: '5px',
          transform: arrow ? 'rotate(180deg)' : 'rotate(0deg)'
        }}
      />
    </IconButton>
  );
}

export default IconButtonComponent;